import { downloadResumePdf } from "@/_components/ui/ResumeUI/_hooks/resumeDownload";

export const LOCKED_RESUME_PREVIEW_PDF_URL = `${process.env.NEXT_PUBLIC_CLOUDFRONT_CDN_URL}/images/knoot-outline.pdf`;

export const LOCKED_PREVIEW_DOWNLOAD_BASENAME = "knoot-outline";

export const RESUME_DETAIL_RESUME_NS =
  "resume_community.talent_pool.resume_detail.resume";

export const downloadPdf = downloadResumePdf;

export type ActiveResumeView = "original" | "ats";

export enum ResumeVersion {
  original = "original",
  digital = "digital",
}
